export default {
    apiKey: "AIzaSyBJkQqccw__-mMa5yxNM3jZ4EREmJZtynQ",
    authDomain: "djibinho-fedde.firebaseapp.com",
    databaseURL: "https://djibinho-fedde.firebaseio.com",
    projectId: "djibinho-fedde",
    storageBucket: "djibinho-fedde.appspot.com",
    messagingSenderId: "59241446445",
    appId: "1:59241446445:web:097e6eb89ec562af548ca4"
}


// WEBPACK FOOTER //
// ./src/components/firebaseConfig.js